import React from 'react';
import { ExternalLinkIcon, FileStackIcon, PlugZapIcon } from 'lucide-react';
import { DetailCard } from '../detail/DetailCard';
interface DocumentRequestPanelProps {
  leadName: string;
  onOpen: () => void;
}

/**
 * Slot for the existing Document Request tool. The real module is embedded
 * here in production — this is a placeholder so the surface is reserved.
 */
export function DocumentRequestPanel({
  leadName,
  onOpen
}: DocumentRequestPanelProps) {
  return <DetailCard title="Document request" action={<button type="button" onClick={onOpen} className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-navy-200 px-3 text-xs font-semibold text-navy-700 hover:bg-navy-50" data-id="element-301" data-mp="3ouad4wemwjwa">
          Open full view
          <ExternalLinkIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-302" data-mp="39z437ycf40xo" />
        </button>} data-id="element-300" data-mp="3ovv5qghe1sri">
      <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-navy-200 bg-navy-50/50 px-5 py-10 text-center" data-id="element-303" data-mp="35wh89okg9zw9">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-white text-navy-500 shadow-card" data-id="element-304" data-mp="2fix0av0w1jlz">
          <FileStackIcon className="h-5 w-5" aria-hidden="true" data-id="element-305" data-mp="2kcrhnrt0tmhw" />
        </span>
        <p className="mt-3 text-sm font-semibold text-navy-900" data-id="element-306" data-mp="25nv8tsj545g8">
          Document Request module
        </p>
        <p className="mt-1 max-w-sm text-xs text-navy-500" data-id="element-307" data-mp="2aj2akusun02i">
          The existing document request experience embeds here for {leadName} —
          request lists, borrower upload status, and reminders.
        </p>
        <span className="mt-4 inline-flex items-center gap-1.5 rounded-full bg-white px-2.5 py-1 text-[11px] font-bold uppercase tracking-wide text-navy-500 ring-1 ring-navy-200" data-id="element-308" data-mp="2pa1cjmz6iqd4">
          <PlugZapIcon className="h-3 w-3" aria-hidden="true" data-id="element-309" data-mp="2tdploa3glu0h" />
          Placeholder for existing build
        </span>
      </div>
    </DetailCard>;
}